import { IncidentStatus } from "../../types/fieldInstance.interface";
import { careFields } from "../helpers/constants";
import {
  incidentRelatedLists,
  transformedInlineRLFields,
} from "../helpers/relatedListHelpers";
import { toArray } from "./getTransformedData";

export function getRLArrays(selectedIncident: any) {
  const rlValues: any = {};
  Object.keys(incidentRelatedLists).forEach((key) => {
    const fieldName = incidentRelatedLists[key];
    const fieldNameObj: { [x: string]: string } = {
      skinIssues: "Skin_Issues",
      careProvided: "Cares_Provided",
    };
    const _fieldName =
      key.charAt(0).toUpperCase() +
      (Object.keys(fieldNameObj).includes(key) ? fieldNameObj[key] : key).slice(
        1
      ) +
      "__r";
    if (selectedIncident?.incidentStatus === IncidentStatus.Draft) {
      return;
    } else {
      rlValues[fieldName] = selectedIncident[_fieldName]?.records || [];
    }
  });
  return rlValues;
}

export function transformArrayValues(
  initialValues: any,
  selectedIncident: any
) {
  const rlArrays = getRLArrays(selectedIncident);
  return Object.keys(initialValues).reduce((acc: any, key: string) => {
    if (initialValues[key] && Array.isArray(initialValues[key])) {
      if (
        //selectedIncident[key] !== undefined &&
        typeof selectedIncident[key] === "string"
      ) {
        acc[key] = toArray(selectedIncident[key], ";");
      }
    }
    return { ...acc, ...rlArrays };
  }, {});
}

function getFieldValue(
  initialValues: any,
  fetchedValue: any,
  fieldName: string
) {
  const value =
    fetchedValue && Array.isArray(initialValues[fieldName])
      ? toArray(fetchedValue, ";")
      : fetchedValue;
  return value ?? initialValues[fieldName];
}

export function populateInlineRLs(selectedIncident: any, initialValues: any) {
  let inlineFields = {};
  Object.keys(transformedInlineRLFields).forEach((fieldName) => {
    const correspondingFieldName = incidentRelatedLists[fieldName];
    const hasValue =
      Array.isArray(selectedIncident[correspondingFieldName]) &&
      !!selectedIncident[correspondingFieldName].length;
    const inlineRLId =
      hasValue && selectedIncident[correspondingFieldName][0]?.Id;
    const obj = Object.keys(transformedInlineRLFields[fieldName]).reduce(
      (acc, field) => {
        if (hasValue) {
          acc[field] = getFieldValue(
            initialValues,
            selectedIncident[correspondingFieldName][0][field],
            field
          );
        } else {
          acc[field] = getFieldValue(
            initialValues,
            selectedIncident[careFields[field as keyof typeof careFields]],
            field
          );
        }
        return acc;
      },
      {} as { [key: string]: string }
    );
    const key = `${fieldName}_id`;
    inlineFields = inlineRLId
      ? { ...inlineFields, ...obj, [key]: inlineRLId }
      : { ...inlineFields, ...obj };
  });
  return inlineFields;
}
